module.exports = __webpack_public_path__ + "04_short_yellow.c079e8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_short_yellow.png
// module id = S/FQ
// module chunks = 0